import { useEffect, useState } from 'react';
import { navLinks, siteInfo } from '@/mocks/buzz';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-surface/95 shadow-soft backdrop-blur' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-coral-500 text-white">
            <i className="ri-news-fill text-lg" />
          </span>
          <span className="font-display text-xl leading-none">
            {siteInfo.brand}
            <span className="ml-1 align-middle text-[11px] font-sans font-bold text-coral-600 tracking-widest">
              {siteInfo.slogan}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-ink-soft transition-colors hover:bg-coral-50 hover:text-coral-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-ink px-4 py-2 text-sm font-bold text-surface transition-colors hover:bg-coral-600 md:inline-flex"
          >
            订阅速览
          </a>
          <button
            aria-label="打开菜单"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-ink transition-colors hover:bg-coral-50 md:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-paper bg-surface px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-ink-soft transition-colors hover:bg-coral-50 hover:text-coral-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-full bg-ink px-4 py-2.5 text-center text-sm font-bold text-surface"
            >
              订阅速览
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}